import React from 'react';
import { useTranslation } from 'react-i18next';
import { PropTypes } from 'prop-types';
import i18n from 'i18next';
import { sanitize } from '@laliga-cdac/react';
import * as S from './styles';

export default function LegalTermsContent({ closeModal, data }) {
  const { t } = useTranslation();
  const lang = i18n.language;

  return (
    <S.StaticContainer>
      <S.Wrapper>
        {data.logo && (
          <S.Logo
            src={data.logo}
            logoWidth={data.logoWidth}
            logoHeight={data.logoHeight}
          />
        )}
        {data[lang].title && <S.Title>{data[lang].title}</S.Title>}
        {data[lang].subtitle && <S.SubTitle>{data[lang].subtitle}</S.SubTitle>}
        <S.Content dangerouslySetInnerHTML={sanitize(data[lang].text)} />
        <S.Close onClick={() => closeModal()}>{t('close')}</S.Close>
      </S.Wrapper>
    </S.StaticContainer>
  );
}

LegalTermsContent.propTypes = {
  closeModal: PropTypes.func,
  data: PropTypes.object,
};

LegalTermsContent.defaultProps = {
  closeModal: () => {},
  data: {},
};
